import { Component, Input, OnInit } from '@angular/core';
import { InterfaceCheckPoint } from 'app/models/check-point.model';
import { InterfaceEmployee } from 'app/models/employee.model';
import { InterfaceJob } from 'app/models/job.model';
import { EmployeeService } from 'app/services/employee.service';
import { take } from 'rxjs/operators';
import { timezone } from 'assets/constants/timezone';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SweetalertService } from 'app/services/sweetalert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DoCheckPointComponent } from '../do-check-point/do-check-point.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
import * as dayOfYear from 'dayjs/plugin/dayOfYear';
import * as isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);
dayjs.extend(dayOfYear);
dayjs.extend(isoWeek)

@Component({
  selector: 'app-activities-supervisor',
  templateUrl: './activities-supervisor.component.html',
  styleUrls: ['./activities-supervisor.component.scss']
})
export class ActivitiesSupervisorComponent implements OnInit {

  @Input() user: InterfaceEmployee;
  jobsInChargeSupervisor: InterfaceJob[] = [];
  checkPointsInCharge: InterfaceCheckPoint[] = [];
  employeesInChargeSupervisor: InterfaceEmployee[] = [];
  checksPointsSupervisor: InterfaceCheckPoint[] = [];
  checkPointsDataSupervisor: any = {};
  selectedEmployee: InterfaceEmployee = {};
  formCheckPoint = new FormGroup({
    comments: new FormControl(null, Validators.required)
  });
  selectedJob: InterfaceJob = {};
  daysCurrentMonth: number[] = [];
  daysCurrentWeek: number[] = [];
  daysCurrentBiweek: number[] = [];

  // dates
  currentdayInYear: number;
  currentDayInMonth: number;
  currentWeekNumber: number;
  currentMonthNumber: number;
  dayOfTheYearMondayCurrentWeek: number;
  firstDayOfCurrentMonth: number;
  daysInCurrentMonth: number;
  firstHalfMonthMaxDay: number;
  secondHalfMonthMaxDay: number;

  constructor(
    protected employeeService: EmployeeService,
    public swal: SweetalertService,
    private spinner: NgxSpinnerService,
    public modal: NgbModal
  ) {
    this.currentdayInYear = dayjs().tz(timezone).dayOfYear();
    this.currentDayInMonth = dayjs().tz(timezone).date();
    this.currentWeekNumber = dayjs().tz(timezone).isoWeek();
    this.currentMonthNumber = dayjs().tz(timezone).month() + 1;
    this.dayOfTheYearMondayCurrentWeek = dayjs().tz(timezone).startOf("isoWeek").dayOfYear();
    this.firstDayOfCurrentMonth = dayjs().tz(timezone).startOf("month").date();
    this.daysInCurrentMonth = dayjs().tz(timezone).endOf("month").date();
    this.firstHalfMonthMaxDay = Number.isInteger(this.daysInCurrentMonth / 2) ? (this.daysInCurrentMonth / 2) : (this.daysInCurrentMonth / 2) + .5;
    this.secondHalfMonthMaxDay = this.daysInCurrentMonth;
    for (let i = 1; i <= dayjs().tz(timezone).endOf("month").date(); i++) {
      this.daysCurrentMonth.push(i);
    }
    for (let i = dayjs().tz(timezone).startOf("isoWeek").date(); i <= dayjs().tz(timezone).endOf("isoWeek").date(); i++) {
      this.daysCurrentWeek.push(i);
    }
    const isFirstHalf = this.currentDayInMonth >= this.firstHalfMonthMaxDay ? false : true;
    for (let i = isFirstHalf ? 1 : this.firstHalfMonthMaxDay; i <= (isFirstHalf ? this.firstHalfMonthMaxDay : this.secondHalfMonthMaxDay); i++) {
      this.daysCurrentBiweek.push(i);
    }
  }

  async ngOnInit(): Promise<void> {
    this.user = await this.employeeService.getCurrentUser();
    this.checkSupervisorJobs();
  }

  // get all jobs with the supervisorId === currentUser.id
  checkSupervisorJobs(): void {
    this.employeeService.getJobsSupervisor(this.user.id).pipe(take(1)).subscribe((result: InterfaceJob[]) => {
      this.jobsInChargeSupervisor = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  // save global the job and check the users with that jobId
  selectJob(job: InterfaceJob): void {
    this.selectedJob = job;
    this.selectedEmployee = {};
    this.checkPointsDataSupervisor = {};
    this.checkUsersSupervisor();
  }

  // get the check points of the current job
  getCheckPointsSupervisor(): void {
    this.employeeService.getCheckPoints(this.selectedJob.id).pipe(take(1)).subscribe((checkPointsResult: InterfaceCheckPoint[]) => {
      this.checksPointsSupervisor = checkPointsResult;
      for (let j = 0; j < this.checksPointsSupervisor.length; j++) {
        this.getCheckPointsDataSupervisor(this.checksPointsSupervisor[j]);
      }
      this.spinner.hide();
    }, (error: any) => {
      console.error(error);
      this.spinner.hide();
    });
  }

  // get the data of the check points mesurement of the supervisor with the current job and current employee selected
  getCheckPointsDataSupervisor(checkPoint: InterfaceCheckPoint): void {
    this.employeeService.getCheckPointsSupervisor(checkPoint, this.user.id, this.selectedEmployee.id).pipe(take(1)).subscribe((checkPointDataResult: any) => {
      if (checkPointDataResult && checkPointDataResult.length > 0) {
        this.checkPointsDataSupervisor[checkPoint.id] = true;
      } else {
        this.checkPointsDataSupervisor[checkPoint.id] = false;
      }
    }, (error: any) => {
      console.error(error);
    });
  }

  // get all the users with the job id 
  checkUsersSupervisor(): void {
    this.employeeService.getEmployeesByJob(this.selectedJob.id).pipe(take(1)).subscribe((result: InterfaceEmployee[]) => {
      this.employeesInChargeSupervisor = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  // save the employee global and get all the checkpoints of the job
  selectEmployee(employee: InterfaceEmployee): void {
    this.selectedEmployee = employee;
    this.checkPointsDataSupervisor = {};
    this.spinner.show(undefined,
      {
        type: 'square-jelly-box',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.getCheckPointsSupervisor();
  }

  doCheckPoint(checkPoint: InterfaceCheckPoint): void {
    const modalRef = this.modal.open(DoCheckPointComponent, {
      backdrop: "static",
      animation: true,
      centered: true
    });
    modalRef.componentInstance.checkPoint = checkPoint;
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.job = this.selectedJob;
    modalRef.componentInstance.employee = this.selectedEmployee;
    modalRef.componentInstance.role = "Supervisor";
    modalRef.result.then((result) => {
      if (result && result.success) {
        this.checkPointsDataSupervisor[checkPoint.id] = true;
      }
    });
  }

  downloadFile(url: string): void {
    window.open(url);
  }

}
